export default __webpack_public_path__ + "img/4a9286bab88aaa7ac45b0c917553aad5.svg";